import dayjs from 'dayjs';

export const getPreviousMonthsByCount = (count: number) => {
  const dates = [];
  for (let i = 0; i < count; i++) {
    const today = new Date();
    today.setMonth(today.getMonth() - i);
    dates.push(dayjs(today).format('MMM YYYY'));
  }

  return dates;
};
